import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { canPlayWebm } from '../shared/canPlayWebm';

export type SupportedVideoMimeType = 'video/mp4; codecs="avc1.424028, mp4a.40.2"' | 'video/webm;codecs="vp8,opus"';

export function useSupportedVideoMimeType(): SupportedVideoMimeType {
	const utilityContext = useUtilityContext();

	return canPlayWebm(utilityContext) ? 'video/webm;codecs="vp8,opus"' : 'video/mp4; codecs="avc1.424028, mp4a.40.2"';
}
